var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFfp2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.666,
    height: 55.666,
    viewBox: "0 0 55.666 55.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_173",
    x: 0,
    y: 0,
    width: 55.666,
    height: 55.666,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FFP2",
    transform: "translate(-10.784 -4.982)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 10.78, 4.98)",
    filter: "url(#Pfad_173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_173-2",
    "data-name": "Pfad 173",
    d: "M123.666,40.833a18.833,18.833,0,1,0-18.833,18.833,18.833,18.833,0,0,0,18.833-18.833",
    transform: "translate(-77 -16)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_174",
    "data-name": "Pfad 174",
    d: "M41.056,98.82a6.636,6.636,0,0,1-1.4-1.632,13.263,13.263,0,0,1-1.042-2.04A10.468,10.468,0,0,1,38,91.555a5.433,5.433,0,0,1,.616-2.471,5.767,5.767,0,0,1,1.318-2,11.217,11.217,0,0,1,1.257-1.122c2.231-1.934,4.991-3.352,6.051-4.27.924-.8,4.11-3.7,6.778-3.7s5.854,2.9,6.778,3.7c1.06.918,3.82,2.335,6.051,4.27a12.733,12.733,0,0,1,1.294,1.208,6.479,6.479,0,0,1,1.282,1.91,5.434,5.434,0,0,1,.616,2.471,10.467,10.467,0,0,1-.616,3.592A11.845,11.845,0,0,1,68.4,97.175a6.368,6.368,0,0,1-1.411,1.645c-2.391,2.231-6.426,3.826-12.964,3.826s-10.579-1.6-12.964-3.826",
    transform: "translate(-15.518 -58.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_176",
    "data-name": "Pfad 176",
    d: "M440.461,222.908a.462.462,0,0,1-.434-.621,9.958,9.958,0,0,0,.588-3.433,4.939,4.939,0,0,0-.567-2.263.462.462,0,1,1,.825-.416,5.923,5.923,0,0,1,.666,2.679,10.877,10.877,0,0,1-.644,3.751.462.462,0,0,1-.434.3",
    transform: "translate(-386.554 -186.224)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_177",
    "data-name": "Pfad 177",
    d: "M85.106,347.071c-6.009,0-10.477-1.329-13.28-3.951a.462.462,0,0,1,.631-.675c2.626,2.456,6.881,3.7,12.648,3.7s10.016-1.246,12.649-3.7a.462.462,0,1,1,.631.676c-2.81,2.621-7.277,3.951-13.279,3.951",
    transform: "translate(-46.603 -302.888)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_178",
    "data-name": "Pfad 178",
    d: "M33.078,222.908a.462.462,0,0,1-.434-.3A10.877,10.877,0,0,1,32,218.854a5.923,5.923,0,0,1,.666-2.679.462.462,0,0,1,.825.416,4.94,4.94,0,0,0-.567,2.263,9.956,9.956,0,0,0,.588,3.434.462.462,0,0,1-.434.621",
    transform: "translate(-9.98 -186.224)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_179",
    "data-name": "Pfad 179",
    d: "M99.556,80.891a.46.46,0,0,1-.3-.113,34.357,34.357,0,0,0-4-2.857A19.944,19.944,0,0,1,93.2,76.508l-.148-.129c-.979-.855-3.959-3.456-6.327-3.456s-5.348,2.6-6.327,3.456l-.148.129a19.946,19.946,0,0,1-2.046,1.413,34.357,34.357,0,0,0-4,2.857.462.462,0,0,1-.606-.7,35.109,35.109,0,0,1,4.112-2.937,19.614,19.614,0,0,0,1.939-1.333l.145-.126C80.947,74.676,84.013,72,86.728,72s5.781,2.676,6.935,3.683l.145.126a19.612,19.612,0,0,0,1.939,1.333,35.1,35.1,0,0,1,4.112,2.937.462.462,0,0,1-.3.811",
    transform: "translate(-48.225 -53.388)",
    fill: "#303e58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_180",
    "data-name": "Pfad 180",
    d: "M172.784,108.621a.465.465,0,0,1-.138-.021,8.216,8.216,0,0,1-2.666-1.286l-.043-.047c-1.792-1.936-2.791-2.343-3.314-2.343s-1.521.406-3.314,2.343l-.045.048A8.22,8.22,0,0,1,160.6,108.6a.462.462,0,0,1-.277-.882,7.76,7.76,0,0,0,2.263-1.03l.045-.049c.6-.653,2.443-2.639,3.992-2.639s3.387,1.986,3.992,2.639l.044.047a7.752,7.752,0,0,0,2.264,1.032.462.462,0,0,1-.138.9",
    transform: "translate(-128.12 -82.923)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_250",
    "data-name": "Pfad 250",
    d: "M12.785,1.711a.465.465,0,0,1-.138-.021A29.6,29.6,0,0,0,6.029.808,16.623,16.623,0,0,0,.6,1.69.462.462,0,0,1,.324.808,17.685,17.685,0,0,1,6.029,0a29.22,29.22,0,0,1,6.895.808.462.462,0,0,1-.138.9",
    transform: "translate(40.022 25.239) rotate(90)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_252",
    "data-name": "Pfad 252",
    d: "M-14.751,7.434q-.225,0-.439-.01a5.616,5.616,0,0,1-2.2-.5A7.167,7.167,0,0,1-19.33,5.183a7.914,7.914,0,0,1-1.74-3.763,13.446,13.446,0,0,1,.314-4.9A11.293,11.293,0,0,1-20-5.653a4.522,4.522,0,0,1,1.077-1.516c1.592-1.34,4.549-.792,6.312.562a32.046,32.046,0,0,0,4.35,2.573.353.353,0,0,1,.162.472.353.353,0,0,1-.472.162,32.118,32.118,0,0,1-4.47-2.647,6.129,6.129,0,0,0-2.836-1.145,3.338,3.338,0,0,0-2.591.563,6.714,6.714,0,0,0-1.6,3.316,12.718,12.718,0,0,0-.3,4.63,7.21,7.21,0,0,0,1.589,3.419,6.63,6.63,0,0,0,1.7,1.553,7.914,7.914,0,0,0,4.648.2,6.92,6.92,0,0,0,2.4-.963,6.409,6.409,0,0,0,.933-.7.353.353,0,0,1,.5.009.353.353,0,0,1-.008.5,6.941,6.941,0,0,1-1.029.781A7.637,7.637,0,0,1-12.3,7.19,13.819,13.819,0,0,1-14.751,7.434Z",
    transform: "translate(33.5 32.947)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_253",
    "data-name": "Pfad 253",
    d: "M-15.516,6.52A8.868,8.868,0,0,1-17.1,6.378a7.637,7.637,0,0,1-2.671-1.072A6.941,6.941,0,0,1-20.8,4.525a.353.353,0,0,1-.008-.5.353.353,0,0,1,.5-.008,6.411,6.411,0,0,0,.933.7,6.92,6.92,0,0,0,2.4.963A8.344,8.344,0,0,0-14.14,5.7a4.99,4.99,0,0,0,1.869-.645c.071-.049.144-.1.221-.149.8-.531,2-1.333,3.03-4.459,1.034-3.142.487-6.252-1.429-8.117a2,2,0,0,0-2.187-.492,10.066,10.066,0,0,0-2.494,1.45c-.215.153-.438.311-.654.457a13.907,13.907,0,0,1-3.28,1.524c-1.023.348-1.806.538-1.839.546a.353.353,0,0,1-.426-.261.353.353,0,0,1,.261-.426,18.355,18.355,0,0,0,4.887-1.967c.21-.143.42-.292.643-.45A10.541,10.541,0,0,1-12.85-8.835a2.944,2.944,0,0,1,1.467-.122,2.784,2.784,0,0,1,1.427.781A6.663,6.663,0,0,1-8.72-6.51a7.825,7.825,0,0,1,.743,2.1,9.128,9.128,0,0,1,.155,2.427A10.789,10.789,0,0,1-8.349.668c-1.105,3.358-2.432,4.241-3.31,4.826-.075.05-.145.1-.211.142a5.613,5.613,0,0,1-2.154.761A9.1,9.1,0,0,1-15.516,6.52Z",
    transform: "translate(72.705 33.523)",
    fill: "#979faf"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfp2);
export default __webpack_public_path__ + "static/media/FFP2.7c3f9f228307fa8d5384bf372014d1e7.svg";
export { ForwardRef as ReactComponent };